<template>
  <div>
    <b-container fluid class="pb-4 px-lg-4">
      <!-- ── SKELETON ── -->
      <div v-if="!apiResponse.success" class="cat-skeleton">
        <div class="cat-sk-toolbar">
          <div class="cat-sk-bar cat-sk-search"></div>
          <div class="cat-sk-bar cat-sk-select"></div>
          <div class="cat-sk-bar cat-sk-btn"></div>
          <div class="cat-sk-bar cat-sk-btn"></div>
        </div>
        <div class="cat-sk-table">
          <div class="cat-sk-table-header">
            <div class="cat-sk-bar" style="width:80px;height:12px;"></div>
            <div class="cat-sk-bar" style="width:150px;height:12px;"></div>
            <div class="cat-sk-bar" style="width:120px;height:12px;"></div>
            <div class="cat-sk-bar" style="width:60px;height:12px;"></div>
            <div class="cat-sk-bar" style="width:70px;height:12px;"></div>
          </div>
          <div v-for="n in 8" :key="n" class="cat-sk-table-row">
            <div class="cat-sk-bar" style="width:70px;height:13px;"></div>
            <div class="cat-sk-bar" style="width:55%;height:13px;"></div>
            <div class="cat-sk-bar" style="width:100px;height:13px;"></div>
            <div class="cat-sk-bar" style="width:40px;height:13px;"></div>
            <div
              class="cat-sk-bar"
              style="width:60px;height:26px;border-radius:8px;"
            ></div>
          </div>
        </div>
      </div>

      <div v-else>
        <!-- Toolbar unificada -->
        <div class="dir-toolbar">
          <div class="dir-toolbar-search">
            <el-input
              v-model="searchQuery"
              placeholder="Buscar producto, código..."
              suffix-icon="el-icon-search"
              size="small"
              clearable
              @input="onSearchDebounced"
            />
          </div>
          <el-select
            v-model="orderByQuery"
            placeholder="Ordenar"
            size="small"
            class="dir-toolbar-select"
          >
            <el-option label="Recientes" value="recent" />
            <el-option label="Nombre A-Z" value="a-z" />
            <el-option label="Nombre Z-A" value="z-a" />
          </el-select>
          <div class="dir-toolbar-right">
            <ExportButtons
              :data="sortedProducts"
              :columns="exportColumns"
              filename="inventario"
            />
            <el-button
              class="btn-primary-custom"
              size="small"
              @click="showModal('inputs')"
            >
              <i class="el-icon-circle-plus"></i> Ingreso
            </el-button>
            <el-button type="danger" size="small" @click="showModal('outputs')">
              <i class="el-icon-remove"></i> Salida
            </el-button>
          </div>
        </div>

        <!-- Tabla de movimientos -->
        <div class="dir-table">
          <div class="dir-table-header mov-table-header">
            <span>Código</span>
            <span class="mov-col-name">Nombre</span>
            <span>Establecimiento</span>
            <span>Stock</span>
            <span>Acciones</span>
          </div>
          <div
            v-for="(product, index) in sortedProducts"
            :key="index"
            class="dir-table-row mov-table-row"
          >
            <span class="mov-code-text">{{ product.code }}</span>
            <span class="mov-col-name mov-name-text">{{ product.name }}</span>
            <span class="mov-establishment-text">{{
              product.establishment
            }}</span>
            <span class="mov-stock-text">{{ product.quantity }}</span>
            <span class="mov-actions">
              <el-tooltip
                content="Trasladar"
                placement="top"
                :enterable="false"
              >
                <button
                  class="mov-icon-btn mov-icon-btn--outline"
                  @click="showModal('transfer', product)"
                >
                  <i class="el-icon-sort"></i>
                </button>
              </el-tooltip>
              <el-tooltip
                content="Ver movimientos"
                placement="top"
                :enterable="false"
              >
                <button
                  class="mov-icon-btn mov-icon-btn--solid"
                  @click="
                    goRouter('catalogue.movements.view', { id: product.id })
                  "
                >
                  <i class="el-icon-document"></i>
                </button>
              </el-tooltip>
            </span>
          </div>
          <div v-if="!sortedProducts.length" class="dir-table-empty">
            Sin resultados
          </div>
        </div>
      </div>
      <!-- end v-else -->

      <infinite-loading :identifier="infiniteId" @infinite="infiniteHandler">
        <div slot="no-more" class="dir-table-empty">No hay más productos</div>
        <div slot="no-results">
          <EmptyPage
            v-if="apiResponse.success"
            icon="el-icon-box"
            text="Registra tus productos o servicios y empieza a ofrecer a tus clientes."
          />
        </div>
        <div slot="spinner"></div>
      </infinite-loading>
    </b-container>

    <WrapperCatalogTourComponent />

    <!-- Dialog: Ingreso / Salida -->
    <el-dialog
      :title="type === 'input' ? 'Ingresos' : 'Salidas'"
      :visible.sync="modalStatus"
    >
      <b-form @submit="onSubmit">
        <b-row>
          <b-col xs="12" sm="12" md="12">
            <b-form-group label="Producto:">
              <SelectProductsComponent
                :show-add="false"
                autocomplete
                @onSelectProduct="onSelectProduct"
              />
            </b-form-group>
            <p>
              <b>Producto Seleccionado:</b>
              {{ form?.user_business_product_name ?? "-" }}
            </p>
          </b-col>
          <b-col xs="12" sm="12" md="6">
            <b-form-group label="Cantidad:">
              <b-form-input
                v-model="form.quantity"
                type="number"
                min="0.00"
                required
              />
            </b-form-group>
          </b-col>
          <b-col xs="12" sm="12" md="6">
            <b-form-group label="Establecimiento:">
              <b-form-select
                v-model="form.establishment_id"
                :options="stablishments"
                required
                value-field="id"
                text-field="name"
              />
            </b-form-group>
          </b-col>
          <b-col xs="12" sm="12" md="12">
            <b-form-group label="Motivo traslado:">
              <b-form-input v-model="form.reason_transfer" required />
            </b-form-group>
          </b-col>
          <b-col xs="12" sm="12" md="12" class="text-right">
            <el-button
              style="background-color:#3fdbbf; color: #fff;"
              native-type="submit"
            >
              <i class="el-icon-plus"></i> Guardar
            </el-button>
          </b-col>
        </b-row>
      </b-form>
    </el-dialog>

    <!-- Dialog: Trasladar -->
    <el-dialog title="Trasladar" :visible.sync="modalTransfers">
      <b-form @submit="onSubmit2">
        <b-row>
          <b-col xs="12" sm="12" md="8">
            <b-form-group label="Producto:">
              <b-form-input
                v-model="formTransfer.user_business_product_name"
                type="text"
                disabled
              />
            </b-form-group>
          </b-col>
          <b-col xs="12" sm="12" md="4">
            <b-form-group label="Cantidad Actual:">
              <b-form-input
                v-model="formTransfer.user_business_product_quantity"
                type="number"
                disabled
              />
            </b-form-group>
          </b-col>
          <b-col xs="12" sm="12" md="8">
            <b-form-group label="Almacén Origen:">
              <b-form-select
                v-model="formTransfer.establishment_origin_id"
                :options="stablishments"
                required
                value-field="id"
                text-field="name"
                disabled
              />
            </b-form-group>
          </b-col>
          <b-col xs="12" sm="12" md="4">
            <b-form-group label="Cantidad a trasladar:">
              <b-form-input
                v-model="formTransfer.quantity"
                type="number"
                min="0.00"
                required
              />
            </b-form-group>
          </b-col>
          <b-col xs="12" sm="12" md="12">
            <b-form-group label="Almacén Destino:">
              <b-form-select
                v-model="formTransfer.establishment_destiny_id"
                :options="stablishments"
                required
                value-field="id"
                text-field="name"
              />
            </b-form-group>
          </b-col>
          <b-col xs="12" sm="12" md="12" class="text-right">
            <el-button
              style="background-color:#3fdbbf; color: #fff;"
              native-type="submit"
            >
              <i class="el-icon-plus"></i> Guardar
            </el-button>
          </b-col>
        </b-row>
      </b-form>
    </el-dialog>

    <!-- Dialog: Ver Movimientos -->
    <el-dialog title="Movimientos" :visible.sync="modalMovements">
      <el-table :data="getTableData" stripe fit style="width: 100%">
        <el-table-column type="index" :index="indexMethod" />
        <el-table-column prop="description" label="Descripción" width="400" />
        <el-table-column prop="quantity" label="Cantidad" width="100" />
        <el-table-column
          prop="created_at"
          label="Fecha"
          :formatter="formatDate"
          width="180"
        />
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[5, 10]"
        :page-size="pageSize"
        :total="totalItems"
        layout="total, sizes, prev, pager, next, jumper"
      />
    </el-dialog>
  </div>
</template>

<script>
import catalogueService from "../../services/catalogueService";
import WrapperCatalogTourComponent from "../WrapperTour";
import EmptyPage from "../../../components/EmptyPage";
import tradeService from "../../../profile/services/tradeService";
import SelectProductsComponent from "../../../components/SelectProducts";

export default {
  name: "MovementListComponent",
  data: () => ({
    filters: { search: null, page: 1 },
    infiniteId: +new Date(),
    hasMore: true,
    apiResponse: { success: false },
    searchQuery: "",
    orderByQuery: "recent",
    products: [],
    modalStatus: false,
    modalTransfers: false,
    modalMovements: false,
    stocks: [],
    form: {
      user_business_product_id: null,
      user_business_product_name: null,
      quantity: null,
      establishment_id: null,
      reason_transfer: ""
    },
    formTransfer: {
      user_business_product_id: null,
      user_business_product_name: null,
      user_business_product_quantity: null,
      quantity: null,
      establishment_origin_id: null,
      establishment_destiny_id: null
    },
    stablishments: [],
    type: "input",
    movementsData: [],
    currentPage: 1,
    pageSize: 5,
    _searchTimer: null
  }),
  computed: {
    expandedProducts() {
      const arr = [];
      this.products.forEach(item => {
        item.stocks.forEach(stock => {
          arr.push({
            id: item.id,
            name: item.name,
            code: item.code,
            establishment: stock.establishment,
            establishment_id: stock.establishment_id,
            quantity: stock.quantity,
            details: stock.details
          });
        });
      });
      return arr;
    },
    sortedProducts() {
      return this.expandedProducts.concat().sort((a, b) => {
        switch (this.orderByQuery) {
          case "recent":
            return (b.id || 0) - (a.id || 0);
          case "old":
            return (a.id || 0) - (b.id || 0);
          case "a-z":
            return (a.name || "")
              .toLowerCase()
              .localeCompare((b.name || "").toLowerCase());
          case "z-a":
            return (b.name || "")
              .toLowerCase()
              .localeCompare((a.name || "").toLowerCase());
          default:
            return 0;
        }
      });
    },
    getTableData() {
      const start = (this.currentPage - 1) * this.pageSize;
      return this.movementsData.slice(start, start + this.pageSize);
    },
    totalItems() {
      return this.movementsData.length;
    },
    exportColumns() {
      return [
        { label: "Código", field: "code" },
        { label: "Nombre", field: "name" },
        { label: "Establecimiento", field: "establishment" },
        { label: "Stock actual", field: "quantity" },
        {
          label: "Movimientos registrados",
          value: i => (i.details ? i.details.length : 0)
        }
      ];
    }
  },
  methods: {
    goRouter(name, params = {}) {
      this.$router.push({ name, params });
    },
    onSearchDebounced() {
      clearTimeout(this._searchTimer);
      this._searchTimer = setTimeout(() => {
        this.filters.search = this.searchQuery || null;
        this.filters.page = 1;
        this.products = [];
        this.hasMore = true;
        this.infiniteId += 1;
      }, 400);
    },
    async onSubmit(event) {
      event.preventDefault();
      if (!this.form.user_business_product_id) {
        return this.$notifications.error({
          message: "No ha seleccionado un producto"
        });
      }
      const operationService =
        this.type === "input"
          ? catalogueService.addInputProduct
          : catalogueService.addOutputProduct;
      this.$store.dispatch("toggleRequestLoading");
      try {
        const response = await operationService(this.form);
        const { success, message } = response.data;
        this.modalStatus = false;
        this.resetList();
        if (success) {
          this.form = {
            user_business_product_id: null,
            user_business_product_name: null,
            quantity: null,
            establishment_id: null,
            reason_transfer: ""
          };
          this.$notifications.success({ message });
        }
      } catch (error) {
        return false;
      } finally {
        this.$store.dispatch("toggleRequestLoading");
      }
    },
    async onSubmit2(event) {
      event.preventDefault();
      this.$store.dispatch("toggleRequestLoading");
      try {
        const response = await catalogueService.moveProduct(this.formTransfer);
        const { success, message } = response.data;
        this.modalTransfers = false;
        this.resetList();
        if (success) {
          this.formTransfer = {
            user_business_product_id: null,
            user_business_product_name: null,
            user_business_product_quantity: null,
            quantity: null,
            establishment_origin_id: null,
            establishment_destiny_id: null
          };
          this.$notifications.success({ message });
        }
      } catch (error) {
        return false;
      } finally {
        this.$store.dispatch("toggleRequestLoading");
      }
    },
    resetList() {
      this.products = [];
      this.filters.page = 1;
      this.hasMore = true;
      this.infiniteId += 1;
    },
    async infiniteHandler($state) {
      if (!this.hasMore) {
        $state.complete();
        return;
      }
      const { page, search } = this.filters;
      try {
        let response = await catalogueService.getProducts({
          params: { page, search, limit: 10 }
        });
        const { products, pagination } = response?.data;
        if (products && products.length) {
          this.products = [...this.products, ...products];
          this.filters.page += 1;
          this.apiResponse.success = true;
          if (!pagination || page >= pagination.total_pages) {
            this.hasMore = false;
            $state.complete();
          } else {
            $state.loaded();
          }
        } else {
          this.apiResponse.success = true;
          this.hasMore = false;
          $state.complete();
        }
      } catch (error) {
        $state.complete();
      }
    },
    showModal(name, data = null) {
      if (name === "inputs") {
        this.type = "input";
        this.modalStatus = true;
      } else if (name === "outputs") {
        this.type = "output";
        this.modalStatus = true;
      } else if (name === "transfer") {
        this.formTransfer.user_business_product_id = data.id;
        this.formTransfer.user_business_product_name = data.name;
        this.formTransfer.user_business_product_quantity = data.quantity;
        this.formTransfer.establishment_origin_id = data.establishment_id;
        this.modalTransfers = true;
      } else {
        this.movementsData = data;
        this.modalMovements = true;
      }
    },
    onSelectProduct({ product }) {
      this.form.user_business_product_id = product.id;
      this.form.user_business_product_name = product.name;
    },
    async getStablishments() {
      try {
        const response = await tradeService.getStablishments();
        this.stablishments = response.data?.data || [];
      } catch (error) {
        return false;
      }
    },
    indexMethod(index) {
      return index + 1;
    },
    formatDate(row) {
      return new Date(row.created_at).toLocaleString("es-ES", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit"
      });
    },
    handleSizeChange(size) {
      this.pageSize = size;
    },
    handleCurrentChange(page) {
      this.currentPage = page;
    }
  },
  components: {
    WrapperCatalogTourComponent,
    EmptyPage,
    SelectProductsComponent
  },
  mounted() {
    this.getStablishments();
  }
};
</script>

<style lang="scss" scoped>
$primary: #31355c;
$border: #e4eaf6;

.btn-primary-custom {
  background-color: #3fdbbf !important;
  color: #fff !important;
  border: none !important;
  &:hover {
    background-color: #36c5ab !important;
  }
}

.dir-toolbar .el-input__inner,
.dir-toolbar .el-select .el-input__inner {
  min-height: 34px !important;
  height: 34px;
  font-size: 13px;
  border-radius: 8px;
}
</style>

<style lang="scss">
.mov-table-header,
.mov-table-row {
  grid-template-columns: 80px 1fr 150px 80px 96px !important;
}
.mov-code-text {
  font-weight: 600;
  color: #31355c;
  font-size: 14px;
}
.mov-col-name {
  min-width: 0;
}
.mov-name-text {
  font-weight: 600;
  color: #31355c;
  font-size: 14px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.mov-establishment-text {
  font-size: 14px;
  color: #606266;
}
.mov-stock-text {
  font-weight: 700;
  color: #31355c;
  text-align: center;
}
.mov-actions {
  display: flex;
  align-items: center;
  gap: 6px;
}
.mov-icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: none;
  cursor: pointer;
  font-size: 15px;
  transition: background 0.15s, transform 0.1s;
  padding: 0;
  &:focus {
    outline: none;
  }
  &:active {
    transform: scale(0.92);
  }
}
.mov-icon-btn--outline {
  background: transparent;
  border: 1.5px solid #3fdbbf !important;
  color: #3fdbbf;
  &:hover {
    background: rgba(#3fdbbf, 0.1);
  }
}
.mov-icon-btn--solid {
  background: #3fdbbf;
  color: #fff;
  &:hover {
    background: #36c5ab;
  }
}

@media (max-width: 768px) {
  .mov-table-header {
    display: none !important;
  }
  .mov-table-row {
    display: flex !important;
    flex-wrap: wrap;
    gap: 6px 12px;
    padding: 16px;
    font-size: 14px;

    .mov-name-text {
      flex-basis: 100%;
      order: -2;
      font-size: 15px;
    }
    .mov-code-text {
      font-size: 13px;
      color: #909399;
    }
    .mov-stock-text {
      text-align: left;
    }
  }
  .mov-actions {
    flex-basis: 100% !important;
    margin-top: 8px;
    gap: 8px;
  }
}

/* ── Catalogue Skeleton ── */
@keyframes cat-shimmer {
  0% {
    background-position: -400px 0;
  }
  100% {
    background-position: 400px 0;
  }
}
.cat-sk-bar {
  border-radius: 6px;
  background: linear-gradient(90deg, #ececec 25%, #f5f5f5 50%, #ececec 75%);
  background-size: 800px 100%;
  animation: cat-shimmer 1.4s infinite linear;
}
.cat-sk-toolbar {
  display: flex;
  gap: 10px;
  align-items: center;
  margin-bottom: 20px;
}
.cat-sk-search {
  height: 32px;
  flex: 1;
  max-width: 360px;
}
.cat-sk-select {
  height: 32px;
  width: 130px;
}
.cat-sk-btn {
  height: 32px;
  width: 90px;
  margin-left: auto;
}
.cat-sk-table {
  border: 1px solid #e4eaf6;
  border-radius: 10px;
  overflow: hidden;
  background: #fff;
}
.cat-sk-table-header {
  display: flex;
  gap: 16px;
  align-items: center;
  padding: 14px 20px;
  background: #f7f8f9;
  border-bottom: 1px solid #e4eaf6;
}
.cat-sk-table-row {
  display: flex;
  gap: 16px;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid #f0f0f0;
  &:last-child {
    border-bottom: none;
  }
}
</style>
